import { Box, Button, Typography, useTheme } from '@mui/material'
import React, { useId } from 'react'
import { Icons } from '../../utils/icons.jsx'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../utils/constants.jsx'
import serverErrorImg from '../../../shared/assets/request-error.svg'
import waitingImg from '../../../shared/assets/waiting.svg'
import noDataImg from '../../../shared/assets/no-data.svg'

const codeToImgMap = {
    500: serverErrorImg,
    400: serverErrorImg,
    404: serverErrorImg,
    401: waitingImg,
    "no-data": noDataImg
}

const Message = ( { retryFunc, type = "message", imgCode, color, img, title, icon, styles = EMPTY_OBJECT, imageStyles = EMPTY_OBJECT, descriptionStyles = EMPTY_OBJECT, description, orientation = "vertical", messageStyles, actions = EMPTY_ARRAY } ) => {

    const { palette, layout, alpha } = useTheme()

    const validActionsPresent = actions.filter( a => a.enabled !== false && ( typeof a.onClick === 'function' && a.label ) || React.isValidElement( a ) ).length > 0

    return (
        <Box sx={{ p: 2, bgcolor: color ? palette[color] ? palette[color].light + "11" : alpha( color, 0.05 ) : palette.contentBg, borderRadius: layout.borderRadius, gap: 2, display: "flex", flexDirection: orientation === "vertical" ? "column" : "row", alignItems: "center", ...styles }}>
            {( img || ( imgCode && codeToImgMap[imgCode] ) ) && <Box
                component="img"
                src={img || codeToImgMap[imgCode]}
                alt={title}
                sx={{
                    width: orientation === "vertical" ? "200px" : "80px",
                    ...imageStyles
                }} />}
            {icon && <Typography
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    aspectRatio: "1 / 1",
                    width: orientation === "vertical" ? "3.2rem" : "2rem",
                    borderRadius: layout.borderRadius,
                    bgcolor: color ? palette[color] ? palette[color].light + "22" : alpha( color, 0.1 ) : palette.action.hover,
                    p: 1,
                    color: color ? palette[color] ? palette[color].main : color : "",
                    fontSize: orientation === "vertical" ? "2rem" : "1rem",
                    ...imageStyles
                }}
            >
                {icon}
            </Typography>}
            <Box sx={{ textAlign: orientation === "vertical" ? "center" : "left" }}>
                <Typography variant='subtitle2' gutterBottom component="h6" sx={{ display: "block", textAlign: orientation === "vertical" ? "center" : "left", ...messageStyles }} >{title}</Typography>
                {description && <Typography variant='body2' sx={{ fontSize: "0.75rem", textAlign: orientation === "vertical" ? "center" : "left", ...descriptionStyles }} >{description}</Typography>}
            </Box>
            {( validActionsPresent || ( retryFunc && typeof retryFunc === 'function' ) ) && <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}>

                {( ( retryFunc && typeof retryFunc === 'function' ) ) && <Button size='small' color="primary" startIcon={Icons.default.Replay} variant="contained" onClick={retryFunc} disableElevation >Retry</Button>}

                {actions.filter( a => a.enabled !== false && ( typeof a.onClick === 'function' && a.label ) || React.isValidElement( a ) ).map( ( action, index ) => {

                    const buttonStyles = action.styles || {}
                    const buttonSize = action.size || 'small'
                    const buttonColor = action.color && action.color in palette ? action.color : "primary"

                    if ( React.isValidElement( action ) )
                        return <Box key={index}>
                            {action}
                        </Box>

                    return (
                        <Button key={index} size={buttonSize} color={buttonColor} startIcon={action.startIcon} endIcon={action.endIcon} variant={action.variant} sx={{ borderRadius: 10, ...buttonStyles }} onClick={action.onClick} disableElevation >{action.label}</Button>
                    )
                } )}
            </Box>}
        </Box>
    )
}

export default Message
